import React, { useState } from "react";
import { saveOrendaAuth, readOrendaAuth, clearOrendaAuth } from "./orendaAuthStorage";

// DEV-ONLY helper for testing the Orenda backend endpoints without going
// through the full Cognito flow — useful when the tester's IP isn't yet
// whitelisted for the Orenda SSO redirect but the backend team can still
// accept a fixed pair of tokens for testing.
//
// Reachable at /orenda-dev-seed. Do NOT ship this route to a customer build.
// Delete the route + this file once real SSO works end-to-end for everyone.

// Tokens extracted from screenshot. If a token is truncated or a character was
// misread by OCR, paste the correct value in the textarea and click "Save".
const SEED_ID_TOKEN =
  "eyJraWQiOiJKYmw1RXFCKzFjK2xJNUMzbzdvTVVIanc1UHVacjhRTm1FQXY0ZnJFTVFnPSIsImFsZyI6IlJTMjU2In0.eyJhdF9oYXNoIjoiOXFoVjhvam9wTmVDd3RNcmRTM1hhUSIsInN1YiI6IjAyMDUxNDY0LTEwODEtNzAzOS0xN2RjLTFjMDE3ZGR1YWJiYiIsImNvZ25pdG86Z3JvdXBzIjpbImV1LXdlc3QtMV83aE5UHh3b05fYm9wYX1tZW50cy1lbnRyYSJdLCJlbWFpbF92ZXJpZm1lZCI6ZmFsc2UsInByb2dyYW1faWQiOiJib3BheW11bnRzIiwic2FuZGJveCI6InRydWUiLCJpc3MiOiJodHRwczovL2NvZ25pdG8taWRwLmV1LXdlc3QtMS5hbWF6b25hd3MuY29tL2V1LXdlc3QtMV83aE5NUHh3b04iLCJjb2duaXRvOnVzZXJuYW1lIjoiYm9wYX1tZW50cy1lbnRyYV9xdzV6dzNldmN4bHJway0yNHVicnVtazBxamxsMTd5Z3Fzcm1qbHlvaDV3Iiwibm9uY2UiOiJRQ3d5VEpyWmJFMU9DQ3M3SUZzbEhoOVV3SnN4RE84NFFqam9kd2VRMFJFc0FRMUxLbEdIY1VNRjlXZ1F0aFFVFVNdFRZZnpUZFhRM1JmMb1BXTGQxODItcXNDMmZ6N21nR2FlN2piMFpBZWYtaVRjNFFBd3lFXZWlVbGpTUmdUNVFWcVQxUVZJRmNPWDZaX2JOb3R6bmU0UWFvSXo1WFVpYVp2M3RCWlVfaFUlLCJvcmlnaW5fanRpIjoiZmhZjk4MGItMmVjNC00ZGFiLTlhMjUtNWY4OTA3NzAzNzIxIiwiYXVkIjoiNWc1dmM3NzgxdG5ldTR1ajNjdWhvMjYzMWkiLCJpZGVudGl0aWVzIjpbeyJkYXRlQ3JlYXRlZCI6IjE3ODYxNDUxMTQ4NjYiLCJ1c2VySWQiOiJxVzV6VzNVNXNYbFJway0yNHVicnVtazBxamxsMTd5Z3Fzcm1qbHlvaDV3IiwicHJvdmlkZXJOYW1lIjoiYm9wYX1tZW50cy1lbnRyYSIsInByb3ZpZGVyVHlwZSI6IlNBTUwiLCJpc3N1ZXIiOm51bGwsInByaW1hcnkiOiJ0cnVlIn1dLCJreW1MiOiJmYWxzZSIsInRva2VuX3VzZSI6ImlkIiwiYXVkIjoiOTE0ODUlMTMzMDcyNDU0MTE5MzAzMzIwOTAyMTE5MzAzMzIwOTAyMTE1MTUtNTNqYm5MTOZmMjZiTiZW1haWwiOiJyZWhhbi5tOi1jJyZhbmRhbXVpbHl5cy5jb20ifQ.mcs2jIrIbYMQuCca490mkGiPNVwNmHLBzbcwiA0x9mx78GoOgJxAezr70v1E28AiVu6ezVCMPrD7toYNwIbpAS6T3v0EK9vVy6SnHRfuT3L_o_WgHPfOyGf3sxWRHx1apGZDSHl5FWAgW5_W7wMFEOAvXcZEKDfU2-vmudBHXW9Iq55wRYy0Bx1mNvthJFBoJIguSyhGyD5tADCIKt-W0wifpHHOOCtzEoOb3RCU9KMU8TPNZOwkZ3WtqKp3PG5X0afv_xApaZYkGIAmzpsolZWbpHQ6YlnxhhGWAK49vrk1sm8vASHS8MmAaepkZnNFUmsgWMPeXi2p5QG9WBg8dg";

const SEED_ACCESS_TOKEN =
  "eyJraWQiOiJxU2NsYVlUN2dmeFVLTkdsSktWS1RsRsdmZIeWZMc3BNMWRuckhxeW9VUHI0PSIsImFsZyI6IlJTMjU2In0.eyJzdWIiOiIwMjA1MTQ2NC0xMDgxLTcwMzktMTdkYy0xYzAxN2RkZWFiYmIiLCJjb2duaXRvOm9keb3VwcyI6WyJldS13ZXN0LTFfN2hOTVB4d290X2JvcGF5bWVudHMtZW50cmEiXSwiaXNzIjoiaHR0cHM6Ly9jb2duaXRvLWlkcC5ldS13ZXN0LTEuYW1hem9uYXdzLmNvbS9ldS13ZXN0LTFfN2hOTVB4d290IiwidmVyc2lvbiI6MiwiY2xpZW50X21kIjoiNWc1dmM3NzgxdG5ldTR1ajNjdWhvMjYzMWkiLCJvcmlnaW5fanRpIjoiZmhZjk4MGItMmVjNC00ZGFiLTlhMjUtNWY4OTA3NzAzNzIxIiwiZXZlbnRfaWQiOiJlNGYxYzcxOC00YzQ4LTQyYWEtOTVjLTgyMDU5MDU3OTAxYSIsInRva2VuX3VzZSI6ImFjY2VzcyIsInNjb3BlIjoiYXdzLmNvZ25pdG8uc21naW4udXNlci5hZG1pbiBvcGVuaWQgcHJvZmlsZSBlbWFpbCIsImF1dGhfdGltZSI6MTc4NjE0NTExMjgsImV4cCI6MTc4NjE0ODcxMSwiaWF0IjoxNzg2MTQ1MTEyLCJqdGkiOiJiNDBmMDdmNy1lMjE0LTQ5YjItYWY1YWU0LTA5OTljMjM3MjhjNiIsInVzZXJuYW1lIjoiYm9wYX1tZW50cy1lbnRyYV9xdzV6dzNldmN4bHJway0yNHVicnVtazBxamxsMTd5Z3Fzcm1qbHlvaDV3In0.MJjxQk4ro7bfOkuY1n5VeKngj2IEck3Itw1gv3KKUtPIurJjN9_pUB8OV9n5VObxNQ-ihzkr5aklcPZPZazWrcoZkKs2k2OuXoRoTTsOTzq4z9TvnaAzWS9gGrT8rJV1P4nMD1rmdJM3oyfM61iqSd9qIXEZnQ4FunfqST4MHUsaJAHomaYQ4MMAXYYg9q3amUuu5z-wPoHAHnE1Sc_si-4smugZU8cdjhZxIkGt18bkH7Zry6xsSjNNrTJy-lE6KAHFf5voCHbIQQl_qgANw7gF4KV_Y1f0YmXIhNYmAwm-vvorExeK5G411tFlGKnRfr6u7nMWxC-7i7of1XBkg";

const OrendaDevSeed = () => {
  const [idToken, setIdToken] = useState(SEED_ID_TOKEN);
  const [accessToken, setAccessToken] = useState(SEED_ACCESS_TOKEN);
  const [saved, setSaved] = useState(false);

  const seed = () => {
    saveOrendaAuth({
      id_token: idToken.trim(),
      access_token: accessToken.trim(),
      refresh_token: "",
      expires_in: 3600,
      token_type: "Bearer",
      scope: "openid email",
    });
    setSaved(true);
    setTimeout(() => setSaved(false), 2000);
  };

  const clear = () => {
    clearOrendaAuth();
    setSaved(false);
  };

  const current = readOrendaAuth();

  return (
    <div style={pageStyle}>
      <div style={{ padding: 10, background: "#fdecea", border: "1px solid #f5c6c1", marginBottom: 20 }}>
        <strong>Dev-only page.</strong> Seeds Orenda tokens into sessionStorage
        so you can hit backend endpoints without running the Cognito flow. Do
        not ship this route to production.
      </div>

      <h2 style={{ marginTop: 0 }}>Seed Orenda tokens</h2>
      <p style={{ color: "#6b6f78" }}>
        Paste fresh tokens here (or leave the pre-filled OCR values) and click
        Save. Then navigate to <code>/orenda-landing</code> to test the API
        calls.
      </p>

      <label style={labelStyle}>id_token</label>
      <textarea
        value={idToken}
        onChange={(e) => setIdToken(e.target.value)}
        style={textareaStyle}
        rows={8}
      />

      <label style={labelStyle}>access_token</label>
      <textarea
        value={accessToken}
        onChange={(e) => setAccessToken(e.target.value)}
        style={textareaStyle}
        rows={8}
      />

      <div style={{ marginTop: 16, display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
        <button onClick={seed} style={primaryButtonStyle}>
          Save to sessionStorage
        </button>
        <button onClick={clear} style={secondaryButtonStyle}>
          Clear
        </button>
        <a href="/orenda-landing" style={linkButtonStyle}>
          Go to /orenda-landing →
        </a>
        {saved && <span style={{ color: "#2f6b3a", fontSize: 13 }}>Saved.</span>}
      </div>

      <div style={{ marginTop: 30 }}>
        <div style={labelStyle}>Currently stored (sessionStorage.orendaAuth)</div>
        <pre style={preStyle}>
          {current ? JSON.stringify(current, null, 2) : "(empty)"}
        </pre>
      </div>
    </div>
  );
};

const pageStyle = {
  padding: "40px 24px",
  maxWidth: 900,
  margin: "0 auto",
  fontFamily:
    "-apple-system, BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif",
  color: "#16181d",
};
const labelStyle = {
  display: "block",
  fontSize: 11,
  letterSpacing: "0.1em",
  textTransform: "uppercase",
  color: "#6b6f78",
  marginTop: 16,
  marginBottom: 6,
};
const textareaStyle = {
  width: "100%",
  fontFamily: "ui-monospace, 'JetBrains Mono', Menlo, monospace",
  fontSize: 11,
  padding: 10,
  border: "1px solid #d8d4cb",
  background: "#fafaf7",
  wordBreak: "break-all",
  resize: "vertical",
};
const primaryButtonStyle = {
  padding: "10px 18px",
  border: "none",
  background: "#16181d",
  color: "white",
  cursor: "pointer",
  fontSize: 14,
  fontWeight: 500,
};
const secondaryButtonStyle = {
  padding: "10px 18px",
  border: "1px solid #d8d4cb",
  background: "white",
  cursor: "pointer",
  fontSize: 14,
};
const linkButtonStyle = {
  padding: "10px 18px",
  border: "1px solid #16181d",
  background: "white",
  color: "#16181d",
  cursor: "pointer",
  fontSize: 14,
  textDecoration: "none",
  fontWeight: 500,
};
const preStyle = {
  background: "#ecebe4",
  padding: 12,
  fontSize: 11,
  fontFamily: "ui-monospace, 'JetBrains Mono', Menlo, monospace",
  maxHeight: 200,
  overflow: "auto",
  margin: 0,
  wordBreak: "break-all",
  whiteSpace: "pre-wrap",
};

export default OrendaDevSeed;
